export const MFA_REQUIRED_ERROR = {
  code: 'MFA_REQUIRED_ERROR',
  message: 'Two-factor authentication is required for this user.',
  httpStatusCode: 401
}
